export const NOT_FOUND = 'Not Found';
